import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-izbeljivanje-zuba',
  templateUrl: './izbeljivanje-zuba.component.html',
  styleUrls: ['./izbeljivanje-zuba.component.css']
})
export class IzbeljivanjeZubaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
